import { render, staticRenderFns } from "./ExtractionDossierDbco.vue?vue&type=template&id=5d4bef33&scoped=true"
import script from "./ExtractionDossierDbco.vue?vue&type=script&lang=js"
export * from "./ExtractionDossierDbco.vue?vue&type=script&lang=js"
import style0 from "./ExtractionDossierDbco.vue?vue&type=style&index=0&id=5d4bef33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4bef33",
  null
  
)

export default component.exports